import React from "react";
import { Box, MenuItem } from "@mui/material";
import Input from "react-phone-number-input/input";
import { getCountryObj } from "../constants";
import "react-phone-number-input/style.css";
import "./phone-input.scss";
import AlertMessage from "../alertMessage/AlertMessage";
import CustomSelect from "../customSelect/CustomSelect";
import { mobileNoPlaceholder, phoneNumberInputLabel } from "../messages";

const PhoneNumberInput = ({ showLabel, ...props }) => {
  return (
    <Box className={props?.boxClassName}>
      {showLabel && (
        <label className="input-with-dropdown-label">{props?.label}</label>
      )}
      <Box className="dropdown-input-wrapper">
        <CustomSelect
          onOpen={() => props?.onOpen && props.onOpen()}
          onClose={() => props?.onClose && props.onClose()}
          value={props?.selectValue}
          showLabel={false}
          MenuProps={props?.MenuProps}
          renderValue={(value) => {
            if (value) {
              let mobileInfo = getCountryObj(
                "calling_code",
                typeof value === "object" ? value.calling_code : value,
                props?.options
              );
              return mobileInfo && mobileInfo.calling_code
                ? "+" + mobileInfo.calling_code
                : "";
            } else {
              return "";
            }
          }}
          onChange={(event) => {
            props?.onChangeSelect(event.target.value);
            setTimeout(() => {
              props?.onBlur();
            }, 100);
          }}
        >
          {props?.options?.map((option) => (
            <MenuItem
              style={{ display: "flex", justifyContent: "space-between" }}
              key={option.id}
              value={option.calling_code}
            >
              <Box> {option.short_name} </Box>
              <Box> {"+" + option.calling_code} </Box>
            </MenuItem>
          ))}
        </CustomSelect>

        <Input
          option={props?.option}
          tabIndex={0}
          className={`phone-number-input ${
            props?.isErrorClass && "phone-number-input-error"
          }`}
          country={props?.countryIsoCode}
          international
          placeholder={mobileNoPlaceholder}
          value={props?.inputValue}
          onBlur={() => {
            props?.onBlur?.();
          }}
          onChange={(value) => {
            props?.onChange(value || null);
          }}
        />
      </Box>
      {props?.error && (
        <AlertMessage
          className="mt-14"
          severity="error"
          message={phoneNumberInputLabel(props?.label)}
        />
      )}
    </Box>
  );
};

export default PhoneNumberInput;
